module.exports = __webpack_public_path__ + "static/img/news47.03ac21d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news47.jpeg
// module id = x9IM
// module chunks = 0